module.exports = __webpack_public_path__ + "img/3-21.14c5a744.jpg";